import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.jpg'


const _hoisted_1 = { id: "productPage" }
const _hoisted_2 = { class: "product-cards" }
const _hoisted_3 = { class: "product-list" }
const _hoisted_4 = { class: "product-info" }
const _hoisted_5 = { class: "product-info" }
const _hoisted_6 = { class: "product-info" }
const _hoisted_7 = { class: "product-process" }
const _hoisted_8 = { class: "steps" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductPage',
  setup(__props) {

const activeIndex = ref(0);
setInterval(() => {
  activeIndex.value = (activeIndex.value + 1) % 6;
}, 800);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "page-header" }, [
      _createElementVNode("h1", null, "服务"),
      _createElementVNode("p", null, "我们提供一系列优质的服务，满足您的多样化需求。")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_card, {
        class: "product-card",
        shadow: "hover"
      }, {
        header: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("i", { class: "el-icon-product" }),
            _createElementVNode("h2", null, "服务一")
          ], -1)
        ])),
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            src: _imports_0,
            alt: "服务一",
            width: "128",
            height: "128"
          }, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, " 这是我们的第一项服务，它具有高效、稳定的特点，能够为您节省大量的时间和精力。 ", -1)),
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("了解更多")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        class: "product-card",
        shadow: "hover"
      }, {
        header: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("i", { class: "el-icon-product" }),
            _createElementVNode("h2", null, "服务二")
          ], -1)
        ])),
        default: _withCtx(() => [
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            src: _imports_0,
            alt: "服务一",
            width: "128",
            height: "128"
          }, null, -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "第二项服务专注于提供个性化的解决方案，根据您的具体需求进行定制。", -1)),
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("了解更多")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        class: "product-card",
        shadow: "hover"
      }, {
        header: _withCtx(() => _cache[8] || (_cache[8] = [
          _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("i", { class: "el-icon-product" }),
            _createElementVNode("h2", null, "服务三")
          ], -1)
        ])),
        default: _withCtx(() => [
          _cache[10] || (_cache[10] = _createElementVNode("img", {
            src: _imports_0,
            alt: "服务一",
            width: "128",
            height: "128"
          }, null, -1)),
          _cache[11] || (_cache[11] = _createElementVNode("p", null, "我们的第三项服务采用了先进的技术，为您提供安全、可靠的保障。", -1)),
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("了解更多")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "list-title" }, "更多优质服务", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _cache[15] || (_cache[15] = _createElementVNode("img", {
            src: "https://via.placeholder.com/100",
            alt: "Product 4"
          }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("h3", null, "服务四：数据智能分析", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, " 借助先进的算法和大数据技术，对您的业务数据进行深度挖掘和分析，为您提供精准的决策依据。无论是市场趋势预测、用户行为分析还是运营效率评估，我们的服务都能帮助您洞察数据背后的价值。 ", -1)),
            _createVNode(_component_el_button, { type: "info" }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("详细了解")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("li", null, [
          _cache[19] || (_cache[19] = _createElementVNode("img", {
            src: "https://via.placeholder.com/100",
            alt: "Product 5"
          }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[17] || (_cache[17] = _createElementVNode("h3", null, "服务五：云端存储与管理", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("p", null, " 提供安全可靠的云端存储解决方案，让您无需担心数据丢失和存储容量问题。我们的云端平台支持多设备同步、数据备份和恢复，确保您的数据随时随地可访问和管理。 ", -1)),
            _createVNode(_component_el_button, { type: "info" }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode("详细了解")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("li", null, [
          _cache[23] || (_cache[23] = _createElementVNode("img", {
            src: "https://via.placeholder.com/100",
            alt: "Product 6"
          }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _cache[21] || (_cache[21] = _createElementVNode("h3", null, "服务六：智能客服系统", -1)),
            _cache[22] || (_cache[22] = _createElementVNode("p", null, " 采用人工智能和自然语言处理技术，打造高效智能的客服系统。能够实时响应客户咨询，自动解答常见问题，提高客户满意度和服务效率。同时，支持与人工客服无缝对接，为客户提供全方位的服务体验。 ", -1)),
            _createVNode(_component_el_button, { type: "info" }, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [
                _createTextVNode("详细了解")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[26] || (_cache[26] = _createElementVNode("h2", { class: "process-title" }, "一站式培训服务流程", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_steps, {
          active: activeIndex.value,
          "finish-status": "finish",
          "process-status": "process",
          "align-center": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_step, {
              title: "需求沟通",
              description: "与您深入沟通需求，了解您的基础和期望。"
            }),
            _createVNode(_component_el_step, {
              title: "方案设计",
              description: "根据需求制定适合您的方案，提供多种可选方案供您选择。"
            }),
            _createVNode(_component_el_step, {
              title: "初步尝试",
              description: "为您提供免费的试听课。"
            }),
            _createVNode(_component_el_step, {
              title: "确定报名",
              description: "报名后即可上课。"
            }),
            _createVNode(_component_el_step, {
              title: "正式培训",
              description: "根据您的基础为您1对1进行培训。"
            }),
            _createVNode(_component_el_step, {
              title: "售后支持",
              description: "提供长期的售后支持和答疑服务，保障您的满意。"
            })
          ]),
          _: 1
        }, 8, ["active"])
      ]),
      _createVNode(_component_el_button, { type: "primary" }, {
        default: _withCtx(() => _cache[25] || (_cache[25] = [
          _createTextVNode("去报名")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})